/*个人中心-子路由*/
export default [
  {
    path: '/userinfo/record',
    name: 'record',
    component: resolve => require(['@/components/userinfo/record/index.vue'], resolve),
    meta: {
      title: '我的活动',
      needLogin: true
    }
  },
  // 门票预约详情
  {
    path: '/userinfo/orderDetail/:id',
    name: 'orderDetail',
    component: resolve => require(['@/components/userinfo/record/orderDetail.vue'], resolve),
    meta: {
      title: '预约详情',
      needLogin: true
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/userinfo/index.js